import {
  Component,
  input,
  computed,
  InputSignal,
  Signal
} from '@angular/core';
import { NumberService } from '../../../services/number/number.service';

@Component({
  selector: 'td-wb-learn-progress-bar',
  templateUrl: 'learn-progress-bar.component.html',
  styleUrls: ['learn-progress-bar.component.scss']
})
export class LearnProgressBarComponent {
  min: InputSignal<number> = input(0);
  max: InputSignal<number> = input(100);
  value: InputSignal<number> = input(0);

  width: Signal<number> = computed(() => {
    const min = this.min();
    const max = this.max();
    const value = this.value();
    // Adjust min and max according to value
    const adjustedMin = min > value ? value : min;
    const adjustedMax = max < value ? value : max;
    const distanceApart = adjustedMax - adjustedMin;
    const remainder = value - adjustedMin;
    const percentageTemp = distanceApart === 0 ? 0 : ((remainder / distanceApart) * 100);
    return NumberService.round(percentageTemp);
  });
}
